var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14ZM11.5652 7C11.5652 9.51726 9.51726 11.5652 7 11.5652C6.18264 11.5652 5.4155 11.3483 4.75117 10.9705L10.9705 4.75117C11.3483 5.4155 11.5652 6.18264 11.5652 7ZM7 2.43478C7.81736 2.43478 8.5845 2.65172 9.24883 3.02954L3.02954 9.24883C2.65172 8.5845 2.43478 7.81736 2.43478 7C2.43478 4.48274 4.48274 2.43478 7 2.43478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.2f81accaf1bbc87bee5623e04593ac8c.svg";
export { ForwardRef as ReactComponent };